import schemas from 'src/modules/shared/yup/yupImporterSchemas';
import { i18n } from 'src/i18n';import contactEnumerators from 'src/modules/contact/contactEnumerators';

export default [
  {
    name: 'source',
    label: i18n('entities.contact.fields.source'),
    schema: schemas.string(
      i18n('entities.contact.fields.source'),
      {
        "required": true,
        "max": 32
      },
    ),
  },
  {
    name: 'firstname',
    label: i18n('entities.contact.fields.firstname'),
    schema: schemas.string(
      i18n('entities.contact.fields.firstname'),
      {
        "required": true,
        "max": 32
      },
    ),
  },
  {
    name: 'lastname',
    label: i18n('entities.contact.fields.lastname'),
    schema: schemas.string(
      i18n('entities.contact.fields.lastname'),
      {
        "required": true,
        "max": 64
      },
    ),
  },
  {
    name: 'email',
    label: i18n('entities.contact.fields.email'),
    schema: schemas.string(
      i18n('entities.contact.fields.email'),
      {
        "required": true,
        "max": 255
      },
    ),
  },
  {
    name: 'categories',
    label: i18n('entities.contact.fields.categories'),
    schema: schemas.relationToMany(
      i18n('entities.contact.fields.categories'),
      {},
    ),
  },    
  {
    name: 'positions',
    label: i18n('entities.contact.fields.positions'),
    schema: schemas.relationToMany(
      i18n('entities.contact.fields.positions'),
      {},
    ),
  },
  {
    name: 'country',
    label: i18n('entities.event.fields.country'),
    schema: schemas.relationToOne(
      i18n('entities.event.fields.country'),
      {},
    ),
  },
  {
    name: 'countryState',
    label: i18n('entities.event.fields.state'),
    schema: schemas.relationToOne(
      i18n('entities.event.fields.countryState'),
      {},
    ),
  },
  {
    name: 'zipCode',
    label: i18n('entities.contact.fields.zipCode'),
    schema: schemas.string(
      i18n('entities.contact.fields.zipCode'),
      {
        "max": 16
      },
    ),
  },  
  {
    name: 'mobile',
    label: i18n('entities.contact.fields.mobile'),
    schema: schemas.string(
      i18n('entities.contact.fields.mobile'),
      {
        "max": 64
      },
    ),
  },  
  {
    name: 'weightUnit',
    label: i18n('entities.contact.fields.weightUnit'),
    schema: schemas.enumerator(
      i18n('entities.contact.fields.weightUnit'),
      {
        "options": contactEnumerators.weightUnit
      },
    ),
  },
  {
    name: 'weight',
    label: i18n('entities.contact.fields.weight'),
    schema: schemas.decimal(
      i18n('entities.contact.fields.weight'),
      {
        "scale": 0
      },
    ),
  }, 
  {
    name: 'gender',
    label: i18n('entities.contact.fields.gender'),
    schema: schemas.enumerator(
      i18n('entities.contact.fields.gender'),
      {
        "options": contactEnumerators.gender
      },
    ),
  },  
];